<script setup lang="ts">
import { h, type VNode } from '#imports';

function isVNodeEmpty(node: VNode) {
  if (typeof node.type === 'object') return false;

  if (!node.children
    || (Array.isArray(node.children) && !node.children.length)
    || node.children === 'v-if') return true;
  
  return false;
}

const props = withDefaults(defineProps<{
  parent?: string;
}>(), {
  parent: 'div',
});

const slots = defineSlots<{
  divider?(): void;
  default?(): void;
}>();

function render() {
  const divider: unknown = slots.divider && slots.divider();
  
  const items =
    slots.default &&
    slots
      .default()
      .reduce((res, el) => {
        // TODO
        if (el.type.toString() === 'Symbol(v-fgt)' && el.children) {
          res.push(...el.children);
        } else {
          res.push(el);
        }
        return res;
      }, [])
      .filter((e: unknown) => !isVNodeEmpty(e))
      .reduce((res, e, i) => {
        if (i !== 0 && divider.length) {
          res.push(divider);
        }
        res.push(e);
        return res;
      }, [] as VNode[]);
  
  return h(props.parent, items);
}
</script>

<template lang="pug">
render
</template>
